import { API_CONFIG_URLS } from "../constants/config";
import type {
  changePasswordPayloadType,
  updateProfilePayloadType,
} from "../lib/types";
import ApiService from "../services/ApiService";

async function getProfileDetails() {
  const response = await ApiService.get(API_CONFIG_URLS.PROFILE.EDIT_PROFILE);
  return response;
}

async function updateProfile(payload: updateProfilePayloadType) {
  const normalizedPayload = {
    ...payload,
    ...(payload?.id ? { Id: payload.id } : {}),
  };

  const response = await ApiService.put(
    API_CONFIG_URLS.PROFILE.EDIT_PROFILE,
    normalizedPayload
  );
  return response;
}

async function changePassword(payload: changePasswordPayloadType) {
  const response = await ApiService.put(
    API_CONFIG_URLS.PROFILE.CHANGE_PASSWORD,
    payload
  );
  return response;
}

export const ProfileApiService = {
  getProfileDetails,
  updateProfile,
  changePassword,
};